module.exports = __webpack_public_path__ + "imgesssyaa/svg/Edit.2de8d18b.svg";